import React, { useState, useEffect } from 'react';
import StripeForm from '../providers/StripeForm';
import SquareForm from '../providers/SquareForm';

const PaymentForm = ({ onSuccess }) => {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/api/payment-config')
      .then(res => {
        if (!res.ok) throw new Error('Payment config failed');
        return res.json();
      })
      .then(data => setConfig(data))
      .catch(err => {
        console.error(err);
        setError('Payment system unavailable');
      });
  }, []);

  if (error) return <div style={{ color: '#D94F2B', textAlign: 'center' }}>{error}</div>;
  if (!config) return <div style={{ color: 'white', textAlign: 'center' }}>Loading payment methods...</div>;

  const handlePaymentSuccess = (result) => {
    if (onSuccess) onSuccess(result);
  };

  if (config.provider === 'stripe') {
    return <StripeForm publicKey={config.publicKey || config.publishableKey} onSuccess={handlePaymentSuccess} />;
  } else if (config.provider === 'square') {
    return <SquareForm appId={config.appId} locationId={config.locationId} onSuccess={handlePaymentSuccess} />;
  }

  return <div style={{ color: '#D94F2B', textAlign: 'center' }}>Unsupported payment provider</div>;
};

export default PaymentForm;
